module.exports = __webpack_public_path__ + "static/media/07_seven_disable_Severe.ebcdd6de.svg";